export const ACCESS_TYPE = 'sse'; // ws or sse
export const APP_KEY = 'iFVxYMuW'; // 体验机器人的appkey



// WEBPACK FOOTER //
// ./src/constants/static.js